/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
import * as Types from '@repo/graphql-types';

import type { FetchOptions } from 'codegen/fetcher/fetcher.types'
import { fetcher } from 'codegen/fetcher'
import { useQuery, type UseQueryOptions, useMutation, type UseMutationOptions } from '@tanstack/react-query'
export type PublicUserProfileQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
}>;


export type PublicUserProfileQuery = { __typename?: 'Query', publicUserProfile: { __typename?: 'PublicUserProfile', id: string, avatarUrl?: string | null, firstName?: string | null, lastName?: string | null, slug?: string | null, displayName?: string | null, shopName?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, superSkill?: string | null, profileUrls?: { __typename?: 'PublicUserProfileUrls', crafter?: string | null, designer?: string | null, teacher?: string | null, theArtistry?: string | null } | null, location: { __typename?: 'UserLocation', country: Types.CountryCode } } };

export type CheckFollowingQueryVariables = Types.Exact<{
  input: Types.UserCheckFollowingInput;
}>;


export type CheckFollowingQuery = { __typename?: 'Query', usersCheckFollowing: boolean };

export type UserCapabilitiesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserCapabilitiesQuery = { __typename?: 'Query', me?: { __typename?: 'AuthResponse', user?: { __typename?: 'User', capabilities: Array<string> } | null } | null };

export type UserProfileInfoQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserProfileInfoQuery = { __typename?: 'Query', me?: { __typename?: 'AuthResponse', user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, avatarUrl?: string | null, contentInterests: Array<string>, machineTypes: Array<string>, craftingTypes: Array<string> } | null } | null };

export type StudioProjectsListProjectsQueryVariables = Types.Exact<{
  input: Types.StudioProjectsListProjectsInput;
}>;


export type StudioProjectsListProjectsQuery = { __typename?: 'Query', studioProjectsListProjects: { __typename?: 'StudioProjectsListProjectsResponse', projects?: Array<{ __typename?: 'StudioProject', id: string, name: string, updateTime: string, createTime: string }> | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type UserOwnFlowsQueryVariables = Types.Exact<{
  take: Types.Scalars['Int']['input'];
  sort?: Types.InputMaybe<Types.FlowPreviewSort>;
}>;


export type UserOwnFlowsQuery = { __typename?: 'Query', flowsPreviewUserFlows: { __typename?: 'FlowsPreviewUserFlowsResponse', hasMore: boolean, previews: Array<{ __typename?: 'FlowPreview', flowId: string, thumbnailUrl?: string | null, isGenerating: boolean, visibility: Types.FlowVisibility }>, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type UserOwnFlowsCountQueryVariables = Types.Exact<{
  take: Types.Scalars['Int']['input'];
  sort?: Types.InputMaybe<Types.FlowPreviewSort>;
}>;


export type UserOwnFlowsCountQuery = { __typename?: 'Query', flowsPreviewUserFlows: { __typename?: 'FlowsPreviewUserFlowsResponse', hasMore: boolean, previews: Array<{ __typename?: 'FlowPreview', flowId: string }>, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type EditUserProfileMutationVariables = Types.Exact<{
  input: Types.EditUserProfileInput;
}>;


export type EditUserProfileMutation = { __typename?: 'Mutation', editUserProfile: { __typename?: 'EditUserProfileResponse', error?: { __typename?: 'ErrorGrowth', type: Types.ErrorTypeGrowth, description?: string | null } | null } };

export type GetDesignerVerificationStatusQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetDesignerVerificationStatusQuery = { __typename?: 'Query', getDesignerVerificationStatus: { __typename?: 'GetDesignerVerificationStatusResponse', status: Types.DesignerVerificationStatus, requestDate: any, error?: { __typename?: 'ErrorGrowth', type: Types.ErrorTypeGrowth, description?: string | null } | null } };

export type UserActivityQueryVariables = Types.Exact<{
  input: Types.ListUserActivityInput;
}>;


export type UserActivityQuery = { __typename?: 'Query', listUserActivity: { __typename?: 'ListUserActivityResponse', items: Array<{ __typename?: 'ActivityItem', userAgent: string, countryCode: string, ipAddress: string, date: string }>, pagination: { __typename?: 'ActivityPagination', totalItems: number, itemsPerPage: number, currentPage: number } } };

export type GetMyAccountUserDobQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMyAccountUserDobQuery = { __typename?: 'Query', getMyAccountUserDob: { __typename?: 'GetMyAccountUserDobResponse', dob: string } };

export type ListSocialLoginAccountsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ListSocialLoginAccountsQuery = { __typename?: 'Query', listSocialLoginAccounts: { __typename?: 'ListSocialLoginAccountsResponse', linkedProfiles: Array<{ __typename?: 'LinkedProfile', providerId: string, providerTitle: string, account: string, loginTimestamp: string, unlinkUrl: string }>, socialProviders: Array<{ __typename?: 'SocialProvider', id: string, authUrl: string }> } };

export type ListAccountNoticesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ListAccountNoticesQuery = { __typename?: 'Query', listAccountNotices: { __typename?: 'ListAccountNoticesResponse', error?: { __typename?: 'ErrorGrowth', type: Types.ErrorTypeGrowth, description?: string | null } | null, notices: Array<{ __typename?: 'MyAccountNotice', type: string, message: string }> } };

export type ListMyAccountNotificationSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ListMyAccountNotificationSettingsQuery = { __typename?: 'Query', listMyAccountNotificationSettings: { __typename?: 'ListMyAccountNotificationSettingsResponse', error?: { __typename?: 'ErrorGrowth', type: Types.ErrorTypeGrowth, description?: string | null } | null, newsletterNotificationSettings: Array<{ __typename?: 'MyAccountNotificationSettings', name: string, enabled: boolean }>, notificationSettings: Array<{ __typename?: 'MyAccountNotificationSettings', name: string, enabled: boolean }> } };

export type UsersBanStatusForCurrentUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UsersBanStatusForCurrentUserQuery = { __typename?: 'Query', usersBanStatusForCurrentUser: { __typename?: 'UsersBanResponse', banStatus: Types.BanStatus } };

export type SaveMyAccountNotificationSettingsMutationVariables = Types.Exact<{
  input: Types.SaveMyAccountNotificationSettingsInput;
}>;


export type SaveMyAccountNotificationSettingsMutation = { __typename?: 'Mutation', saveMyAccountNotificationSettings: { __typename?: 'SaveMyAccountNotificationSettingsResponse', error?: { __typename?: 'ErrorGrowth', type: Types.ErrorTypeGrowth, description?: string | null } | null } };


export const EditUserProfileDocument = `
mutation editUserProfile($input: EditUserProfileInput!) {
  editUserProfile(input: $input) {
    error {
      type
      description
    }
  }
}

`

export const editUserProfileMutationKey = 'editUserProfile'

export function editUserProfileMutationFetcher(variables: EditUserProfileMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<EditUserProfileMutation, EditUserProfileMutationVariables>(EditUserProfileDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useEditUserProfileMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<EditUserProfileMutation, E, EditUserProfileMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<EditUserProfileMutation, E, EditUserProfileMutationVariables, C>({
        ...options,
        mutationKey: [editUserProfileMutationKey],
        mutationFn: (variables: EditUserProfileMutationVariables) => editUserProfileMutationFetcher(variables, fetchOptions),
    })
}

export const SaveMyAccountNotificationSettingsDocument = `
mutation saveMyAccountNotificationSettings($input: SaveMyAccountNotificationSettingsInput!) {
  saveMyAccountNotificationSettings(input: $input) {
    error {
      type
      description
    }
  }
}

`

export const saveMyAccountNotificationSettingsMutationKey = 'saveMyAccountNotificationSettings'

export function saveMyAccountNotificationSettingsMutationFetcher(variables: SaveMyAccountNotificationSettingsMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<SaveMyAccountNotificationSettingsMutation, SaveMyAccountNotificationSettingsMutationVariables>(SaveMyAccountNotificationSettingsDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useSaveMyAccountNotificationSettingsMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<SaveMyAccountNotificationSettingsMutation, E, SaveMyAccountNotificationSettingsMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<SaveMyAccountNotificationSettingsMutation, E, SaveMyAccountNotificationSettingsMutationVariables, C>({
        ...options,
        mutationKey: [saveMyAccountNotificationSettingsMutationKey],
        mutationFn: (variables: SaveMyAccountNotificationSettingsMutationVariables) => saveMyAccountNotificationSettingsMutationFetcher(variables, fetchOptions),
    })
}

export const PublicUserProfileDocument = `
query publicUserProfile($slug: String!) {
  publicUserProfile(slug: $slug) {
    id
    avatarUrl
    firstName
    lastName
    slug
    displayName
    shopName
    avatarUrl
    profileUrls {
      crafter
      designer
      teacher
      theArtistry
    }
    isCreativeFabrica
    isVerified
    isPremium
    isFollowed
    location {
      country
    }
    following
    isTemporary
    superSkill
  }
}

`

export const publicUserProfileQueryRootKey = 'publicUserProfile'

export function publicUserProfileQueryFetcher(variables: PublicUserProfileQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<PublicUserProfileQuery, PublicUserProfileQueryVariables>(PublicUserProfileDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function publicUserProfileQueryKey(variables: PublicUserProfileQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [publicUserProfileQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function publicUserProfileQueryOptions(
    variables: PublicUserProfileQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<PublicUserProfileQuery, unknown, PublicUserProfileQuery, (PublicUserProfileQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: publicUserProfileQueryKey(variables, fetchOptions),
        queryFn: publicUserProfileQueryFetcher(variables, fetchOptions),
    }
}

export function usePublicUserProfileQuery<D = PublicUserProfileQuery, E = unknown>(
    variables: PublicUserProfileQueryVariables,
    options?: Omit<UseQueryOptions<PublicUserProfileQuery, E, D, (PublicUserProfileQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<PublicUserProfileQuery, E, D, (PublicUserProfileQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...publicUserProfileQueryOptions(variables, fetchOptions),
    })
}

export const CheckFollowingDocument = `
query checkFollowing($input: UserCheckFollowingInput!) {
  usersCheckFollowing(input: $input)
}

`

export const checkFollowingQueryRootKey = 'checkFollowing'

export function checkFollowingQueryFetcher(variables: CheckFollowingQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<CheckFollowingQuery, CheckFollowingQueryVariables>(CheckFollowingDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function checkFollowingQueryKey(variables: CheckFollowingQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [checkFollowingQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function checkFollowingQueryOptions(
    variables: CheckFollowingQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<CheckFollowingQuery, unknown, CheckFollowingQuery, (CheckFollowingQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: checkFollowingQueryKey(variables, fetchOptions),
        queryFn: checkFollowingQueryFetcher(variables, fetchOptions),
    }
}

export function useCheckFollowingQuery<D = CheckFollowingQuery, E = unknown>(
    variables: CheckFollowingQueryVariables,
    options?: Omit<UseQueryOptions<CheckFollowingQuery, E, D, (CheckFollowingQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<CheckFollowingQuery, E, D, (CheckFollowingQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...checkFollowingQueryOptions(variables, fetchOptions),
    })
}

export const UserCapabilitiesDocument = `
query userCapabilities {
  me {
    user {
      capabilities
    }
  }
}

`

export const userCapabilitiesQueryRootKey = 'userCapabilities'

export function userCapabilitiesQueryFetcher(variables?: UserCapabilitiesQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<UserCapabilitiesQuery, UserCapabilitiesQueryVariables>(UserCapabilitiesDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function userCapabilitiesQueryKey(variables?: UserCapabilitiesQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [userCapabilitiesQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function userCapabilitiesQueryOptions(
    variables?: UserCapabilitiesQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<UserCapabilitiesQuery, unknown, UserCapabilitiesQuery, (UserCapabilitiesQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: userCapabilitiesQueryKey(variables, fetchOptions),
        queryFn: userCapabilitiesQueryFetcher(variables, fetchOptions),
    }
}

export function useUserCapabilitiesQuery<D = UserCapabilitiesQuery, E = unknown>(
    variables?: UserCapabilitiesQueryVariables,
    options?: Omit<UseQueryOptions<UserCapabilitiesQuery, E, D, (UserCapabilitiesQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<UserCapabilitiesQuery, E, D, (UserCapabilitiesQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...userCapabilitiesQueryOptions(variables, fetchOptions),
    })
}

export const UserProfileInfoDocument = `
query userProfileInfo {
  me {
    user {
      firstName
      lastName
      avatarUrl
      contentInterests
      machineTypes
      craftingTypes
    }
  }
}

`

export const userProfileInfoQueryRootKey = 'userProfileInfo'

export function userProfileInfoQueryFetcher(variables?: UserProfileInfoQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<UserProfileInfoQuery, UserProfileInfoQueryVariables>(UserProfileInfoDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function userProfileInfoQueryKey(variables?: UserProfileInfoQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [userProfileInfoQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function userProfileInfoQueryOptions(
    variables?: UserProfileInfoQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<UserProfileInfoQuery, unknown, UserProfileInfoQuery, (UserProfileInfoQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: userProfileInfoQueryKey(variables, fetchOptions),
        queryFn: userProfileInfoQueryFetcher(variables, fetchOptions),
    }
}

export function useUserProfileInfoQuery<D = UserProfileInfoQuery, E = unknown>(
    variables?: UserProfileInfoQueryVariables,
    options?: Omit<UseQueryOptions<UserProfileInfoQuery, E, D, (UserProfileInfoQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<UserProfileInfoQuery, E, D, (UserProfileInfoQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...userProfileInfoQueryOptions(variables, fetchOptions),
    })
}

export const StudioProjectsListProjectsDocument = `
query studioProjectsListProjects($input: StudioProjectsListProjectsInput!) {
  studioProjectsListProjects(input: $input) {
    projects {
      id
      name
      updateTime
      createTime
    }
    errors {
      code
      message
    }
  }
}

`

export const studioProjectsListProjectsQueryRootKey = 'studioProjectsListProjects'

export function studioProjectsListProjectsQueryFetcher(variables: StudioProjectsListProjectsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<StudioProjectsListProjectsQuery, StudioProjectsListProjectsQueryVariables>(StudioProjectsListProjectsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function studioProjectsListProjectsQueryKey(variables: StudioProjectsListProjectsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [studioProjectsListProjectsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function studioProjectsListProjectsQueryOptions(
    variables: StudioProjectsListProjectsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<StudioProjectsListProjectsQuery, unknown, StudioProjectsListProjectsQuery, (StudioProjectsListProjectsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: studioProjectsListProjectsQueryKey(variables, fetchOptions),
        queryFn: studioProjectsListProjectsQueryFetcher(variables, fetchOptions),
    }
}

export function useStudioProjectsListProjectsQuery<D = StudioProjectsListProjectsQuery, E = unknown>(
    variables: StudioProjectsListProjectsQueryVariables,
    options?: Omit<UseQueryOptions<StudioProjectsListProjectsQuery, E, D, (StudioProjectsListProjectsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<StudioProjectsListProjectsQuery, E, D, (StudioProjectsListProjectsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...studioProjectsListProjectsQueryOptions(variables, fetchOptions),
    })
}

export const UserOwnFlowsDocument = `
query userOwnFlows($take: Int!, $sort: FlowPreviewSort) {
  flowsPreviewUserFlows(input: {take: $take, sort: $sort}) {
    previews {
      flowId
      thumbnailUrl
      isGenerating
      visibility
    }
    hasMore
    errors {
      code
      message
    }
  }
}

`

export const userOwnFlowsQueryRootKey = 'userOwnFlows'

export function userOwnFlowsQueryFetcher(variables: UserOwnFlowsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<UserOwnFlowsQuery, UserOwnFlowsQueryVariables>(UserOwnFlowsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function userOwnFlowsQueryKey(variables: UserOwnFlowsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [userOwnFlowsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function userOwnFlowsQueryOptions(
    variables: UserOwnFlowsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<UserOwnFlowsQuery, unknown, UserOwnFlowsQuery, (UserOwnFlowsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: userOwnFlowsQueryKey(variables, fetchOptions),
        queryFn: userOwnFlowsQueryFetcher(variables, fetchOptions),
    }
}

export function useUserOwnFlowsQuery<D = UserOwnFlowsQuery, E = unknown>(
    variables: UserOwnFlowsQueryVariables,
    options?: Omit<UseQueryOptions<UserOwnFlowsQuery, E, D, (UserOwnFlowsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<UserOwnFlowsQuery, E, D, (UserOwnFlowsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...userOwnFlowsQueryOptions(variables, fetchOptions),
    })
}

export const UserOwnFlowsCountDocument = `
query userOwnFlowsCount($take: Int!, $sort: FlowPreviewSort) {
  flowsPreviewUserFlows(input: {take: $take, sort: $sort}) {
    previews {
      flowId
    }
    hasMore
    errors {
      code
      message
    }
  }
}

`

export const userOwnFlowsCountQueryRootKey = 'userOwnFlowsCount'

export function userOwnFlowsCountQueryFetcher(variables: UserOwnFlowsCountQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<UserOwnFlowsCountQuery, UserOwnFlowsCountQueryVariables>(UserOwnFlowsCountDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function userOwnFlowsCountQueryKey(variables: UserOwnFlowsCountQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [userOwnFlowsCountQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function userOwnFlowsCountQueryOptions(
    variables: UserOwnFlowsCountQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<UserOwnFlowsCountQuery, unknown, UserOwnFlowsCountQuery, (UserOwnFlowsCountQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: userOwnFlowsCountQueryKey(variables, fetchOptions),
        queryFn: userOwnFlowsCountQueryFetcher(variables, fetchOptions),
    }
}

export function useUserOwnFlowsCountQuery<D = UserOwnFlowsCountQuery, E = unknown>(
    variables: UserOwnFlowsCountQueryVariables,
    options?: Omit<UseQueryOptions<UserOwnFlowsCountQuery, E, D, (UserOwnFlowsCountQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<UserOwnFlowsCountQuery, E, D, (UserOwnFlowsCountQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...userOwnFlowsCountQueryOptions(variables, fetchOptions),
    })
}

export const GetDesignerVerificationStatusDocument = `
query GetDesignerVerificationStatus {
  getDesignerVerificationStatus {
    status
    requestDate
    error {
      type
      description
    }
  }
}

`

export const GetDesignerVerificationStatusQueryRootKey = 'GetDesignerVerificationStatus'

export function GetDesignerVerificationStatusQueryFetcher(variables?: GetDesignerVerificationStatusQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<GetDesignerVerificationStatusQuery, GetDesignerVerificationStatusQueryVariables>(GetDesignerVerificationStatusDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function GetDesignerVerificationStatusQueryKey(variables?: GetDesignerVerificationStatusQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [GetDesignerVerificationStatusQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function GetDesignerVerificationStatusQueryOptions(
    variables?: GetDesignerVerificationStatusQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<GetDesignerVerificationStatusQuery, unknown, GetDesignerVerificationStatusQuery, (GetDesignerVerificationStatusQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: GetDesignerVerificationStatusQueryKey(variables, fetchOptions),
        queryFn: GetDesignerVerificationStatusQueryFetcher(variables, fetchOptions),
    }
}

export function useGetDesignerVerificationStatusQuery<D = GetDesignerVerificationStatusQuery, E = unknown>(
    variables?: GetDesignerVerificationStatusQueryVariables,
    options?: Omit<UseQueryOptions<GetDesignerVerificationStatusQuery, E, D, (GetDesignerVerificationStatusQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<GetDesignerVerificationStatusQuery, E, D, (GetDesignerVerificationStatusQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...GetDesignerVerificationStatusQueryOptions(variables, fetchOptions),
    })
}

export const UserActivityDocument = `
query userActivity($input: ListUserActivityInput!) {
  listUserActivity(input: $input) {
    items {
      userAgent
      countryCode
      ipAddress
      date
    }
    pagination {
      totalItems
      itemsPerPage
      currentPage
    }
  }
}

`

export const userActivityQueryRootKey = 'userActivity'

export function userActivityQueryFetcher(variables: UserActivityQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<UserActivityQuery, UserActivityQueryVariables>(UserActivityDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function userActivityQueryKey(variables: UserActivityQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [userActivityQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function userActivityQueryOptions(
    variables: UserActivityQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<UserActivityQuery, unknown, UserActivityQuery, (UserActivityQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: userActivityQueryKey(variables, fetchOptions),
        queryFn: userActivityQueryFetcher(variables, fetchOptions),
    }
}

export function useUserActivityQuery<D = UserActivityQuery, E = unknown>(
    variables: UserActivityQueryVariables,
    options?: Omit<UseQueryOptions<UserActivityQuery, E, D, (UserActivityQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<UserActivityQuery, E, D, (UserActivityQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...userActivityQueryOptions(variables, fetchOptions),
    })
}

export const GetMyAccountUserDobDocument = `
query GetMyAccountUserDob {
  getMyAccountUserDob {
    dob
  }
}

`

export const GetMyAccountUserDobQueryRootKey = 'GetMyAccountUserDob'

export function GetMyAccountUserDobQueryFetcher(variables?: GetMyAccountUserDobQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<GetMyAccountUserDobQuery, GetMyAccountUserDobQueryVariables>(GetMyAccountUserDobDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function GetMyAccountUserDobQueryKey(variables?: GetMyAccountUserDobQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [GetMyAccountUserDobQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function GetMyAccountUserDobQueryOptions(
    variables?: GetMyAccountUserDobQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<GetMyAccountUserDobQuery, unknown, GetMyAccountUserDobQuery, (GetMyAccountUserDobQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: GetMyAccountUserDobQueryKey(variables, fetchOptions),
        queryFn: GetMyAccountUserDobQueryFetcher(variables, fetchOptions),
    }
}

export function useGetMyAccountUserDobQuery<D = GetMyAccountUserDobQuery, E = unknown>(
    variables?: GetMyAccountUserDobQueryVariables,
    options?: Omit<UseQueryOptions<GetMyAccountUserDobQuery, E, D, (GetMyAccountUserDobQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<GetMyAccountUserDobQuery, E, D, (GetMyAccountUserDobQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...GetMyAccountUserDobQueryOptions(variables, fetchOptions),
    })
}

export const ListSocialLoginAccountsDocument = `
query ListSocialLoginAccounts {
  listSocialLoginAccounts {
    linkedProfiles {
      providerId
      providerTitle
      account
      loginTimestamp
      unlinkUrl
    }
    socialProviders {
      id
      authUrl
    }
  }
}

`

export const ListSocialLoginAccountsQueryRootKey = 'ListSocialLoginAccounts'

export function ListSocialLoginAccountsQueryFetcher(variables?: ListSocialLoginAccountsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ListSocialLoginAccountsQuery, ListSocialLoginAccountsQueryVariables>(ListSocialLoginAccountsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function ListSocialLoginAccountsQueryKey(variables?: ListSocialLoginAccountsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [ListSocialLoginAccountsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function ListSocialLoginAccountsQueryOptions(
    variables?: ListSocialLoginAccountsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ListSocialLoginAccountsQuery, unknown, ListSocialLoginAccountsQuery, (ListSocialLoginAccountsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: ListSocialLoginAccountsQueryKey(variables, fetchOptions),
        queryFn: ListSocialLoginAccountsQueryFetcher(variables, fetchOptions),
    }
}

export function useListSocialLoginAccountsQuery<D = ListSocialLoginAccountsQuery, E = unknown>(
    variables?: ListSocialLoginAccountsQueryVariables,
    options?: Omit<UseQueryOptions<ListSocialLoginAccountsQuery, E, D, (ListSocialLoginAccountsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ListSocialLoginAccountsQuery, E, D, (ListSocialLoginAccountsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...ListSocialLoginAccountsQueryOptions(variables, fetchOptions),
    })
}

export const ListAccountNoticesDocument = `
query listAccountNotices {
  listAccountNotices {
    error {
      type
      description
    }
    notices {
      type
      message
    }
  }
}

`

export const listAccountNoticesQueryRootKey = 'listAccountNotices'

export function listAccountNoticesQueryFetcher(variables?: ListAccountNoticesQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ListAccountNoticesQuery, ListAccountNoticesQueryVariables>(ListAccountNoticesDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function listAccountNoticesQueryKey(variables?: ListAccountNoticesQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [listAccountNoticesQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function listAccountNoticesQueryOptions(
    variables?: ListAccountNoticesQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ListAccountNoticesQuery, unknown, ListAccountNoticesQuery, (ListAccountNoticesQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: listAccountNoticesQueryKey(variables, fetchOptions),
        queryFn: listAccountNoticesQueryFetcher(variables, fetchOptions),
    }
}

export function useListAccountNoticesQuery<D = ListAccountNoticesQuery, E = unknown>(
    variables?: ListAccountNoticesQueryVariables,
    options?: Omit<UseQueryOptions<ListAccountNoticesQuery, E, D, (ListAccountNoticesQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ListAccountNoticesQuery, E, D, (ListAccountNoticesQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...listAccountNoticesQueryOptions(variables, fetchOptions),
    })
}

export const ListMyAccountNotificationSettingsDocument = `
query listMyAccountNotificationSettings {
  listMyAccountNotificationSettings {
    error {
      type
      description
    }
    newsletterNotificationSettings {
      name
      enabled
    }
    notificationSettings {
      name
      enabled
    }
  }
}

`

export const listMyAccountNotificationSettingsQueryRootKey = 'listMyAccountNotificationSettings'

export function listMyAccountNotificationSettingsQueryFetcher(variables?: ListMyAccountNotificationSettingsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ListMyAccountNotificationSettingsQuery, ListMyAccountNotificationSettingsQueryVariables>(ListMyAccountNotificationSettingsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function listMyAccountNotificationSettingsQueryKey(variables?: ListMyAccountNotificationSettingsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [listMyAccountNotificationSettingsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function listMyAccountNotificationSettingsQueryOptions(
    variables?: ListMyAccountNotificationSettingsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ListMyAccountNotificationSettingsQuery, unknown, ListMyAccountNotificationSettingsQuery, (ListMyAccountNotificationSettingsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: listMyAccountNotificationSettingsQueryKey(variables, fetchOptions),
        queryFn: listMyAccountNotificationSettingsQueryFetcher(variables, fetchOptions),
    }
}

export function useListMyAccountNotificationSettingsQuery<D = ListMyAccountNotificationSettingsQuery, E = unknown>(
    variables?: ListMyAccountNotificationSettingsQueryVariables,
    options?: Omit<UseQueryOptions<ListMyAccountNotificationSettingsQuery, E, D, (ListMyAccountNotificationSettingsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ListMyAccountNotificationSettingsQuery, E, D, (ListMyAccountNotificationSettingsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...listMyAccountNotificationSettingsQueryOptions(variables, fetchOptions),
    })
}

export const UsersBanStatusForCurrentUserDocument = `
query usersBanStatusForCurrentUser {
  usersBanStatusForCurrentUser {
    banStatus
  }
}

`

export const usersBanStatusForCurrentUserQueryRootKey = 'usersBanStatusForCurrentUser'

export function usersBanStatusForCurrentUserQueryFetcher(variables?: UsersBanStatusForCurrentUserQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<UsersBanStatusForCurrentUserQuery, UsersBanStatusForCurrentUserQueryVariables>(UsersBanStatusForCurrentUserDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function usersBanStatusForCurrentUserQueryKey(variables?: UsersBanStatusForCurrentUserQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [usersBanStatusForCurrentUserQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function usersBanStatusForCurrentUserQueryOptions(
    variables?: UsersBanStatusForCurrentUserQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<UsersBanStatusForCurrentUserQuery, unknown, UsersBanStatusForCurrentUserQuery, (UsersBanStatusForCurrentUserQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: usersBanStatusForCurrentUserQueryKey(variables, fetchOptions),
        queryFn: usersBanStatusForCurrentUserQueryFetcher(variables, fetchOptions),
    }
}

export function useUsersBanStatusForCurrentUserQuery<D = UsersBanStatusForCurrentUserQuery, E = unknown>(
    variables?: UsersBanStatusForCurrentUserQueryVariables,
    options?: Omit<UseQueryOptions<UsersBanStatusForCurrentUserQuery, E, D, (UsersBanStatusForCurrentUserQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<UsersBanStatusForCurrentUserQuery, E, D, (UsersBanStatusForCurrentUserQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...usersBanStatusForCurrentUserQueryOptions(variables, fetchOptions),
    })
}